export const PERMISSION_DEVICE = {
  CREATE: 'DeviceModule.create',
  VIEW: 'DeviceModule.view',
  UPDATE: 'DeviceModule.update',
  DELETE: 'DeviceModule.delete',
};
